// Convert title to URL-friendly slug
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')    // Remove special characters
    .replace(/\s+/g, '-')        // Replace spaces with hyphens
    .replace(/-+/g, '-');        // Remove consecutive hyphens
}

// Generate a unique slug by adding a timestamp if needed
export function generateUniqueSlug(title: string): string {
  const baseSlug = slugify(title);
  const timestamp = new Date().getTime();
  return `${baseSlug}-${timestamp}`;
}